import React from "react";
import {TitleAppBar, TitleAppBarProps} from "~/ui/AppBar/TitleAppBar";
import {Box, Container, Toolbar} from "@mui/material";
import {useHistory} from "react-router-dom";
import {AbsoluteContainer} from "~/apps/core/ui/AbsoluteContainer";


export type TitleLayoutProps = TitleAppBarProps & {
    children?: any,
    title?: any
    back?: boolean
    disableGutters?: boolean
}


const defaultProps: Partial<TitleLayoutProps> = {
    back: true
}


export const TitleLayout = ({children, title, back, disableGutters, ...otherProps}: TitleLayoutProps) => {
    const history = useHistory();

    const handleBack = () => {
        history.goBack();
    }

    return (
        <>
            <TitleAppBar onBack={back ? handleBack : null} {...otherProps} title={title}/>
            <AbsoluteContainer disableGutters={disableGutters} top={56}>
                {children || ""}
            </AbsoluteContainer>
        </>
    )
}

TitleLayout.defaultProps = defaultProps;